import { apiFetch } from "@pontimed/api-client";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useAdminContext } from "@/lib/admin-context";

import { normalizeConnections } from "./types";

/**
 * Every Ads query key starts with this prefix, so one invalidation refreshes
 * the whole console after a sync, a retry or an OAuth round-trip.
 */
export const ADS_QUERY_PREFIX = ["admin", "ads"] as const;

/**
 * GET /api/admin/ads/connections — shared by the Accounts, Campaigns (filter)
 * and Guardrails tabs. `dbTarget` is in the key so the Local↔Prod admin toggle
 * refetches instead of serving the other database's rows.
 */
export function useAdConnections() {
  const { dbTarget } = useAdminContext();
  return useQuery({
    queryKey: [...ADS_QUERY_PREFIX, "connections", dbTarget],
    queryFn: async () =>
      normalizeConnections(await apiFetch.get<unknown>("/api/admin/ads/connections")),
    staleTime: 30_000,
  });
}

/** Refresh every Ads query (connections, campaigns, conversions, overview, live). */
export function useInvalidateAds() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: [...ADS_QUERY_PREFIX] });
}
